// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
  max-width: 800px;
  margin: auto;
  /* background: var(--bg-100); */
  color: var(--text-100);
  min-height: 100vh;
  font-family: system-ui, sans-serif;
  padding-bottom: 80px;
}

.profile-header {
  display: flex;
  gap: 16px;
  padding: 20px;

}

.profile-avatar {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  border: 3px solid var(--primary-100);
  object-fit: cover;
}

.main-profile-header {
  margin-top: 20px;
  background: var(--primary-300);
  border-bottom: 1px solid var(--bg-200);
}

.profile-info h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.bio {
  color: var(--text-200);
  font-size: 13px;
  margin-top: 4px;
}


.stats {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-top: 20px;
}

.stats div {
  /* text-align: center; */
  display: flex;
  flex-direction: column;
}

.stats strong {
  font-size: 14px;
  color: var(--primary-200);
}

.stats span {
  display: block;
  font-size: 13px;
  /* margin-left: 5px; */
  color: var(--text-200);
}


.cta-buttons {
  display: flex;
  gap: 10px;
  padding: 0 20px;
  margin-top: 10px;
}

.btn {
  flex: 1 1;
  padding: 10px;
  border-radius: 10px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

.primary {
  background: var(--primary-100);
  color: var(--primary-300);
}

.btn.primary {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
}

.btn.secondary {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
}

.secondary {
  background: transparent;
  border: 1px solid var(--primary-200);
  color: var(--primary-200);
}

.insights {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 20px;
}

.insight-card {
  background: var(--primary-300);
  padding: 12px;
  border-radius: 14px;
  text-align: center;
  font-size: 12px;
  border: 1px solid var(--bg-200);
  display: flex;
  gap: 4px;
}

.insight-card svg {
  font-size: 18px;
  margin-bottom: 6px;
  color: var(--primary-100);
}

.insight-card span {
  color: var(--text-200);
}

.tabs {
  position: sticky;
  top: 0;
  z-index: 50;
  /* top: 50px; */

  display: flex;
  border-top: 1px solid var(--bg-200);
  background: var(--primary-300);

  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.tabs button {
  flex: 1 1;
  padding: 12px;
  background: none;
  border: none;
  color: var(--text-200);
  font-weight: 600;
}

.tabs .active {
  color: var(--primary-100);
  border-bottom: 3px solid var(--primary-100);
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2px;
}

.grid-item {
  aspect-ratio: 1 / 1;
  background: var(--bg-200);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-300);
  font-size: 18px;
  position: relative;
  overflow: hidden;
}

.grid-item img {
  width: 100%;
  object-fit: cover;
}

.grid,
.reels-grid {
  position: relative;
  min-height: calc(100vh - 320px);
}


.reels-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
}

.reel-item {
  position: relative;
  aspect-ratio: 9/16;
  overflow: hidden;
  border-radius: 6px;
  background: black;
}

.reel-item video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


@media (max-width: 768px) {
  .profile-container {
    max-width: 100%;
  }

  .profile-header {
    padding-top: 20px;
  }

  .empty-state {
    width: 100%;
  }
}


.profile-top-bar {
  max-width: 1000px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding: 12px 16px;
  /* background: var(--bg-100); */
  border-bottom: 1px solid var(--bg-200);
  position: sticky;
  top: 0;
  z-index: 100;
}

.back-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

.top-actions {
  font-size: 20px;
  cursor: pointer;
}

.profile-bio {
  font-size: 14px;
  color: var(--text-200);
  max-width: 420px;
  padding: 15px;
}

.text-posts {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 20px;
  padding: 0 10px;
  position: relative;
  min-height: calc(100vh - 320px);
}

.text-post-card {
  background: white;
  padding: 18px;
  border-radius: 14px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  transition: 0.2s;
}

.text-post-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
}

.text-post-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.text-post-header img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.text-post-header strong {
  font-size: 14px;
  display: block;
}

.post-date {
  font-size: 12px;
  color: var(--text-200);
}

.text-post-content {
  font-size: 15px;
  line-height: 1.6;
  color: var(--text-100);
  margin-top: 8px;
  white-space: pre-line;
}

.text-post-actions {
  display: flex;
  gap: 20px;
  margin-top: 12px;
  font-size: 14px;
  color: var(--text-200);
}

.text-post-actions span {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}

.post-viewer-overlay {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: flex-end;
  z-index: 999;
}

.post-viewer {
  width: 420px;
  height: 100%;
  background: white;
  overflow-y: auto;
  animation: slideViewer .25s ease;
  padding: 20px;
}

@keyframes slideViewer {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

.viewer-close {
  position: sticky;
  top: 0;
  background: white;
  border: none;
  font-size: 18px;
  cursor: pointer;
  margin-bottom: 10px;
}


.skeleton {
  background: linear-gradient(90deg,
      #f0f0f0 25%,
      #e4e4e4 37%,
      #f0f0f0 63%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
  border-radius: 8px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}


.skeleton-avatar {
  width: 90px;
  height: 90px;
  border-radius: 50%;
}


.grid-skeleton {
  width: 100%;
  aspect-ratio: 1/1;
  border-radius: 6px;
}


.text-post-skeleton {
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 12px;
  margin-bottom: 15px;
}

.empty-state {
  position: absolute;
  inset: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;
  color: #888;
}

.empty-state svg {
  margin-bottom: 10px;
  opacity: 0.6;
}

.empty-state h4 {
  font-size: 18px;
  margin-bottom: 5px;
}

.empty-state p {
  font-size: 14px;
}


.follow-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.follow-modal {
  width: 350px;
  max-height: 500px;
  background: white;
  border-radius: 12px;
  padding: 15px;
  display: flex;
  flex-direction: column;
}

.follow-search {
  padding: 8px;
  border-radius: 20px;
  border: 1px solid #ddd;
  margin-bottom: 10px;
  font-size: 16px;
}

.follow-list {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.follow-item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}


.follow-user-icon {
  background-color: var(--primary-200);
  padding: 10px;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.flw-icon {}

.follow-item:hover {
  background: #f5f5f5;
  border-radius: 8px;
}

.follow-avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  object-fit: cover;
}



.follow-search-wrap {
  margin: 16px;
  height: 48px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 12px;
  border: 1px solid transparent;
  transition: .2s ease;
}

.follow-search-wrap:focus-within {
  border-color: rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.08);
}


/* ITEM */

.follow-item {
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 14px;

  padding: 12px;

  border-radius: 20px;

  transition: .22s ease;

  cursor: pointer;
}

.follow-item:hover {
  background: rgba(255, 255, 255, 0.05);

  transform: translateY(-1px);
}

.follow-item-left {
  display: flex;
  align-items: center;
  gap: 14px;

  flex: 1 1;
}

.follow-search-icon {
  opacity: .6;
  font-size: 14px;
}

.follow-search {
  flex: 1 1;

  border: none;
  outline: none;

  background: transparent;


  font-size: 14px;
}



.follow-empty-state {
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;

  opacity: .9;

  padding: 30px;
}

.follow-empty-icon {
  font-size: 48px;
  margin-bottom: 14px;
}

.follow-empty-state h4 {
  font-size: 18px;
  margin-bottom: 8px;
}

.follow-empty-state p {
  opacity: .65;
  max-width: 260px;
  line-height: 1.5;
}



.follow-btn {
  margin-left: auto;
  padding: 5px 10px;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  background: var(--primary-200);
  color: white;
  font-size: 12px;
}

.follow-btn.following {
  background: #eee;
  color: black;
}


.follow-page-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 999;
}

.follow-page {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  max-width: 400px;
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  animation: slideInRight 0.3s ease;
}

.follow-page.closing {
  animation: slideOutRight 0.3s ease;
}


.follow-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.follow-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px;
}


@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes slideOutRight {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(100%);
  }
}




.highlights-section {
  width: 92%;
  margin: 20px auto;
}

.highlights-section h3 {
  font-size: 18px;
  margin-bottom: 12px;
  font-weight: 700;
  color: #111;
}

.highlights-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.highlight-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  border: 1px solid #ececec;
  padding: 14px 16px;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, .04);
  transition: .2s;
}

.highlight-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, .08);
}

.highlight-dot {
  width: 10px;
  height: 10px;
  min-width: 10px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff5f6d, #ffc371);
}

.highlight-card p {
  margin: 0;
  font-size: 14px;
  color: #222;
  line-height: 1.5;
}

.no-highlights {
  color: #888;
  text-align: center;
  padding: 20px;
  background: #fafafa;
  border-radius: 14px;
}

.skeleton-highlight {
  display: flex;
  align-items: center;
  gap: 12px;
}

.skeleton-dot {
  width: 10px;
  height: 10px;
  min-width: 10px;
  border-radius: 50%;
}





/* TOP BAR */

.sport-profile-topbar {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 20px;
}

/* BUTTON */

.sport-back-btn {
  display: flex;
  align-items: center;
  gap: 14px;

  border: none;
  outline: none;

  cursor: pointer;

  padding: 14px 18px;
  margin-bottom: 10px;

  border-radius: 22px;

  background: rgba(255, 255, 255, 0.08);

  backdrop-filter: blur(12px);

  /* color: white; */

  transition: all 0.25s ease;

  min-width: 220px;

  box-shadow:
    0 4px 18px rgba(0, 0, 0, 0.12);

  border: 1px solid rgba(255, 255, 255, 0.08);
  color: var(--primary-200);
}

.sport-back-btn:hover {
  transform: translateY(-2px);

  background: rgba(255, 255, 255, 0.12);

  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.18);
}

/* ARROW */

.back-arrow {
  width: 42px;
  height: 42px;

  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 20px;
  font-weight: bold;

  background: rgba(255, 255, 255, 0.12);
}

/* TEXT */

.back-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.back-label {
  font-size: 15px;
  font-weight: 700;
}

.back-content small {
  opacity: 0.7;
  font-size: 12px;
}

/* MOBILE */

@media (max-width: 768px) {

  .sport-profile-topbar {
    /* margin-bottom: 12px; */
    margin-top: 0;
  }

  .sport-back-btn {
    width: 100%;
    min-width: unset;

    padding: 12px 14px;

    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;

    /* border-radius: 18px; */
  }

  .back-arrow {
    width: 36px;
    height: 36px;

    font-size: 18px;
  }

  .back-label {
    font-size: 14px;
  }

  .back-content small {
    font-size: 11px;
  }
}



/* links */


.profile-links-section {
  margin-top: 10px;
}

.profile-links-title {
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 700;
  margin-left: 20px;
}

.profile-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: 20px;

}

.profile-link {
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 5px 10px;

  border-radius: 12px;

  text-decoration: none;

  background: rgba(255, 255, 255, .04);

  border: 1px solid rgba(255, 255, 255, .08);

  color: var(--primary-200);

  transition: .3s;

  word-break: break-all;
}

.profile-link:hover {
  transform: translateY(-2px);
  color: var(--primary-100);
}



.pinned-badge {

  position: absolute;

  top: 10px;
  right: 10px;

  z-index: 5;

  width: 30px;
  height: 30px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  background: var(--primary-100);

  backdrop-filter:
    blur(10px);

  color: white;

  font-size: 14px;

}


.photo-wow {
  width: 90px;
  height: 90px;
  min-width: 90px;
  min-height: 90px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  border: 3px solid var(--primary-100);
}

.photo-wow img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.profile-display-name {
  display: flex;
  min-width: 0;
  align-items: center;
}

.profile-display-name h2 {
  min-width: 0;
}

.photo-wow-clickable {
  position: relative;
  cursor: zoom-in;
  transition: transform .2s ease, box-shadow .2s ease;
}

.photo-wow-clickable::after {
  content: "";
  position: absolute;
  inset: 3px;
  border-radius: inherit;
  background: rgba(2, 6, 23, 0);
  transition: background .2s ease;
}

.photo-wow-clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(233, 90, 19, .24);
}

.photo-wow-clickable:hover::after {
  background: rgba(2, 6, 23, .1);
}

.photo-wow-clickable:focus-visible {
  outline: 3px solid rgba(233, 90, 19, .3);
  outline-offset: 4px;
}

.profile-photo-viewer {
  position: fixed;
  inset: 0;
  z-index: 12000;
  display: grid;
  place-items: center;
  overflow: hidden;
  padding: 32px;
  background: rgba(2, 6, 23, .76);
  animation: profile-photo-viewer-in .24s ease both;
  isolation: isolate;
}

.profile-photo-viewer-backdrop {
  position: absolute;
  z-index: -2;
  inset: -60px;
  background-position: center;
  background-size: cover;
  filter: blur(42px) saturate(.85);
  opacity: .55;
  transform: scale(1.12);
}

.profile-photo-viewer::after {
  content: "";
  position: absolute;
  z-index: -1;
  inset: 0;
  background:
    radial-gradient(circle at center, rgba(15, 23, 42, .12), rgba(2, 6, 23, .72) 72%),
    rgba(2, 6, 23, .3);
  backdrop-filter: blur(10px);
}

.profile-photo-viewer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  animation: profile-photo-content-in .38s cubic-bezier(.2, .85, .25, 1.15) both;
}

.profile-photo-viewer-ring {
  width: min(58vw, 470px);
  aspect-ratio: 1;
  padding: 7px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f97316, #e95a13 44%, #fbbf24);
  box-shadow:
    0 0 0 6px rgba(255, 255, 255, .1),
    0 28px 80px rgba(0, 0, 0, .55),
    0 0 70px rgba(233, 90, 19, .25);
}

.profile-photo-viewer-ring img {
  display: block;
  width: 100%;
  height: 100%;
  border: 5px solid #fff;
  border-radius: 50%;
  object-fit: cover;
  background: #eaf0f4;
}

.profile-photo-viewer-content p {
  max-width: min(80vw, 480px);
  overflow: hidden;
  margin: 24px 0 0;
  color: #fff;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: .01em;
  text-overflow: ellipsis;
  text-shadow: 0 2px 14px rgba(0, 0, 0, .7);
  white-space: nowrap;
}

.profile-photo-viewer-close {
  position: absolute;
  top: max(22px, env(safe-area-inset-top));
  right: max(22px, env(safe-area-inset-right));
  display: grid;
  place-items: center;
  width: 46px;
  height: 46px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, .24);
  border-radius: 50%;
  color: #fff;
  background: rgba(15, 23, 42, .5);
  backdrop-filter: blur(14px);
  cursor: pointer;
  font-size: 19px;
  transition: transform .2s ease, background .2s ease;
}

.profile-photo-viewer-close:hover {
  background: rgba(233, 90, 19, .78);
  transform: rotate(8deg) scale(1.05);
}

@keyframes profile-photo-viewer-in {
  from { opacity: 0; }
}

@keyframes profile-photo-content-in {
  from { opacity: 0; transform: scale(.78); }
}

@media (max-width: 600px) {
  .profile-photo-viewer {
    padding: 22px;
  }

  .profile-photo-viewer-ring {
    width: min(82vw, 360px);
    padding: 5px;
  }

  .profile-photo-viewer-ring img {
    border-width: 4px;
  }

  .profile-photo-viewer-close {
    top: max(16px, env(safe-area-inset-top));
    right: max(16px, env(safe-area-inset-right));
    width: 42px;
    height: 42px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .profile-photo-viewer,
  .profile-photo-viewer-content {
    animation: none;
  }
}

/* Futuristic profile surface: dense information, calm technology. */
.pro-profile-container {
  min-height: 100vh;
  padding: 24px;
  background: #f4f7f8;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.profile-container {
  max-width: 1180px;
  margin: 0 auto;
  padding-bottom: 46px;
  color: #1d394f;
}

.sport-profile-topbar {
  justify-content: flex-start;
  /* margin: 0 0 18px; */
}

.sport-back-btn {
  width: fit-content;
  max-width: 100%;
  min-width: 0;
  padding: 10px 14px;
  border: 1px solid rgba(78, 119, 153, .18);
  /* border-radius: 14px; */
  color: #345269;
  background: #fbfcfd;
  box-shadow: 0 8px 20px rgba(30, 63, 88, .07), inset 0 1px #ffffff;
}

.sport-back-btn:hover {
  color: #d84f0d;
  background: #fff8f4;
  box-shadow: 0 11px 24px rgba(30, 63, 88, .1);
}

.back-arrow {
  width: 34px;
  height: 34px;
  color: #e95a13;
  background: #fff3ec;
  font-size: 17px;
}

.back-label {
  font-size: .82rem;
  font-weight: 800;
  letter-spacing: .005em;
}

.back-content small {
  color: #71899b;
  font-size: .68rem;
  opacity: 1;
}

.main-profile-header {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(280px, .75fr);
  grid-template-rows: auto auto;
  gap: 16px;
  margin: 0;
  padding: 20px;
  border: 1px solid rgba(78, 119, 153, .16);
  border-radius: 22px;
  background: #fbfcfd;
  box-shadow: 0 18px 40px rgba(30, 63, 88, .08), inset 0 1px #ffffff;
}

.main-profile-header::before {
  content: "";
  grid-column: 1 / -1;
  height: 2px;
  margin: -20px 28px 0;
  border-radius: 0 0 3px 3px;
  background: #e95a13;
}

.profile-header {
  grid-row: 2 / span 2;
  align-items: flex-start;
  gap: 18px;
  min-height: 156px;
  padding: 18px;
  border: 1px solid rgba(78, 119, 153, .13);
  border-radius: 17px;
  background: #ffffff;
}

.photo-wow {
  width: 104px;
  height: 104px;
  min-width: 104px;
  min-height: 104px;
  padding: 0;
  border: 2px solid #e95a13;
  border-radius: 19px;
  background: transparent;
  box-shadow: 0 10px 22px rgba(233, 90, 19, .17);
}

.photo-wow img {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  object-fit: cover;
}

.profile-info {
  min-width: 0;
  flex: 1 1;
}

.profile-info h2 {
  overflow: hidden;
  margin: 4px 0 5px;
  color: #1d394f;
  font-size: 1.4rem;
  font-weight: 850;
  letter-spacing: -.02em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bio {
  display: inline-flex;
  margin: 0;
  padding: 5px 9px;
  border: 1px solid rgba(78, 119, 153, .14);
  border-radius: 999px;
  color: #4e7799;
  background: #edf3f6;
  font-size: .73rem;
  font-weight: 750;
  letter-spacing: .01em;
  text-transform: capitalize;
}

.stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 20px;
}

.stats div {
  min-width: 0;
  padding: 10px;
  border: 1px solid rgba(78, 119, 153, .12);
  border-radius: 12px;
  background: #f6f9fa;
  transition: .18s ease;
}

.stats div:hover {
  border-color: rgba(233, 90, 19, .25);
  background: #fff8f4;
  transform: translateY(-2px);
}

.stats strong {
  color: #e95a13;
  font-size: 1rem;
  font-weight: 850;
}

.stats span {
  overflow: hidden;
  margin-top: 3px;
  color: #71899b;
  font-size: .67rem;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-summary,
.profile-links-section {
  padding: 16px;
  border: 1px solid rgba(78, 119, 153, .13);
  border-radius: 17px;
  background: #ffffff;
}

.profile-summary {
  min-height: 62px;
}

.profile-summary-empty {
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}

.profile-bio {
  max-width: none;
  margin: 0;
  padding: 0;
  color: #345269;
  font-size: .83rem;
  font-weight: 500;
  line-height: 1.65;
}

.profile-links-section {
  margin-top: 0;
}

.profile-links-title {
  margin: 0 0 10px;
  color: #29475e;
  font-size: .76rem;
  font-weight: 850;
  letter-spacing: .07em;
  text-transform: uppercase;
}

.profile-links {
  gap: 7px;
  margin: 0;
}

.profile-link {
  padding: 8px 10px;
  border: 1px solid rgba(78, 119, 153, .13);
  border-radius: 10px;
  color: #4e7799;
  background: #f4f8fa;
  font-size: .73rem;
  font-weight: 650;
}

.profile-link:hover {
  border-color: rgba(233, 90, 19, .25);
  color: #d84f0d;
  background: #fff3ec;
}

.cta-buttons {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: 100%;
  gap: 9px;
  margin: 14px 0 0;
  padding: 0;
}

.cta-buttons .btn {
  min-width: 0;
  width: 100%;
  min-height: 42px;
  padding: 9px 16px;
  border-radius: 11px;
  font-family: inherit;
  font-size: .78rem;
  font-weight: 800;
  transition: .18s ease;
}

.cta-buttons .profile-edit-btn {
  width: 100%;
}

.cta-buttons .primary {
  border: 1px solid #e95a13;
  background: #e95a13;
  box-shadow: 0 8px 18px rgba(233, 90, 19, .18);
}

.cta-buttons .primary:hover {
  background: #d84f0d;
  transform: translateY(-1px);
}

.cta-buttons .secondary {
  border-color: rgba(78, 119, 153, .26);
  color: #4e7799;
  background: #ffffff;
}

.cta-buttons .secondary:hover {
  border-color: rgba(233, 90, 19, .3);
  color: #d84f0d;
  background: #fff3ec;
}

.highlights-section {
  width: auto;
  margin: 16px 0;
}

.highlights-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 10px;
}

.highlight-card {
  min-height: 48px;
  padding: 12px 14px;
  border-color: rgba(78, 119, 153, .14);
  border-radius: 13px;
  box-shadow: 0 7px 17px rgba(30, 63, 88, .05);
}

.highlight-card:hover {
  border-color: rgba(233, 90, 19, .25);
  box-shadow: 0 10px 21px rgba(30, 63, 88, .08);
}

.highlight-dot {
  background: #e95a13;
  box-shadow: 0 0 0 4px rgba(233, 90, 19, .12);
}

.highlight-card p {
  color: #345269;
  font-size: .78rem;
  font-weight: 600;
}

.tabs {
  top: 76px;
  gap: 5px;
  margin-top: 20px;
  padding: 6px;
  border: 1px solid rgba(78, 119, 153, .16);
  border-radius: 14px;
  background: #fbfcfd;
  box-shadow: 0 8px 20px rgba(30, 63, 88, .06);
}

.tabs button {
  padding: 10px;
  border-radius: 9px;
  color: #71899b;
  font-family: inherit;
  font-size: .76rem;
  font-weight: 800;
  letter-spacing: .02em;
  transition: .18s ease;
}

.tabs button:hover {
  color: #d84f0d;
  background: #fff3ec;
}

.tabs .active {
  border: 0;
  color: #e95a13;
  background: #fff3ec;
  box-shadow: inset 0 0 0 1px rgba(233, 90, 19, .14);
}

.grid,
.reels-grid {
  gap: 10px;
  min-height: 280px;
  margin-top: 14px;
}

.grid-item {
  border: 1px solid rgba(78, 119, 153, .14);
  border-radius: 14px;
  background: #eaf0f4;
  transition: .2s ease;
}

.grid-item:hover {
  border-color: rgba(233, 90, 19, .4);
  box-shadow: 0 11px 24px rgba(30, 63, 88, .13);
  transform: translateY(-2px);
}

.grid-item img {
  height: 100%;
}

.reel-item {
  border: 1px solid rgba(78, 119, 153, .14);
  border-radius: 14px;
}

.pinned-badge {
  top: 9px;
  right: 9px;
  width: 32px;
  height: 32px;
  background: #e95a13;
  box-shadow: 0 6px 13px rgba(233, 90, 19, .25);
}

.text-posts {
  gap: 12px;
  margin-top: 14px;
  padding: 0;
  min-height: 280px;
}

.text-post-card {
  padding: 16px;
  border: 1px solid rgba(78, 119, 153, .14);
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(30, 63, 88, .06);
}

.text-post-content {
  color: #345269;
  font-size: .88rem;
}

.skeleton {
  background: #eaf0f4;
  animation: profile-skeleton-pulse 1.2s ease-in-out infinite alternate;
}

@keyframes profile-skeleton-pulse {
  from { opacity: .55; }
  to { opacity: 1; }
}

.profile-container button:focus-visible,
.profile-container a:focus-visible {
  outline: 2px solid #e95a13;
  outline-offset: 2px;
}

@media (max-width: 768px) {
  .pro-profile-container {
    padding: 0 10px 84px;
  }

  .profile-container {
    padding-bottom: 0;
  }

  .sport-profile-topbar {
    margin-bottom: 10px;

  }

  .sport-back-btn {
    width: 100%;
    /* border-radius: 14px; */
  }

  .main-profile-header {
    display: flex;
    flex-direction: column;
    gap: 11px;
    padding: 12px;
    border-radius: 17px;
  }

  .main-profile-header::before {
    width: calc(100% - 40px);
    margin: -12px auto 0;
  }

  .profile-header {
    min-height: 0;
    gap: 12px;
    padding: 13px;
    border-radius: 13px;
  }

  .photo-wow {
    width: 74px;
    height: 74px;
    min-width: 74px;
    min-height: 74px;
    border-radius: 15px;
  }

  .photo-wow img {
    border-radius: 12px;
  }

  .profile-info h2 {
    margin-top: 0;
    font-size: 1.08rem;
  }

  .bio {
    font-size: .65rem;
  }

  .stats {
    gap: 5px;
    margin-top: 13px;
  }

  .stats div {
    padding: 8px 6px;
    border-radius: 9px;
  }

  .stats strong {
    font-size: .84rem;
  }

  .stats span {
    font-size: .58rem;
  }

  .profile-summary,
  .profile-links-section {
    padding: 13px;
    border-radius: 13px;
  }

  .profile-summary-empty { display: none; }

  .profile-bio {
    font-size: .77rem;
  }

  .cta-buttons {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
    gap: 7px;
    margin-top: 12px;
  }

  .cta-buttons .btn {
    min-width: 0;
    width: 100%;
    min-height: 40px;
    padding: 8px 9px;
    font-size: .7rem;
    white-space: nowrap;
  }

  .cta-buttons .profile-edit-btn {
    width: 100%;
  }

  .highlights-list {
    grid-template-columns: 1fr;
  }

  .tabs {
    top: 76px;
    margin-top: 14px;
    border-radius: 12px;
  }

  .tabs button {
    padding: 9px 4px;
    font-size: .64rem;
  }

  .grid,
  .reels-grid {
    gap: 5px;
    margin-top: 10px;
  }

  .grid-item,
  .reel-item {
    border-radius: 9px;
  }
}

/* Followers / following: animated CarrerUp network panel. */
.follow-page-overlay {
  display: flex;
  justify-content: flex-end;
  padding: 12px;
  background: rgba(20, 43, 61, .48);
  backdrop-filter: blur(12px);
}

.follow-page {
  position: relative;
  top: auto;
  right: auto;
  width: min(100%, 440px);
  max-width: none;
  height: 100%;
  overflow: hidden;
  border: 1px solid rgba(148, 169, 186, .38);
  border-radius: 22px;
  color: #1d394f;
  background: #fbfcfd;
  box-shadow: 0 28px 72px rgba(12, 31, 47, .32), inset 0 1px #ffffff;
  animation: follow-panel-in .35s cubic-bezier(.2, .8, .2, 1);
}

.follow-page::before {
  content: "";
  position: absolute;
  top: 0;
  right: 34px;
  left: 34px;
  height: 3px;
  border-radius: 0 0 4px 4px;
  background: #e95a13;
}

.follow-page.closing { animation: follow-panel-out .25s ease-in forwards; }

.follow-header {
  min-height: 76px;
  gap: 11px;
  padding: 18px 18px 14px;
  border-bottom: 1px solid rgba(78, 119, 153, .14);
}

.follow-header .back-btn {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  width: 36px;
  height: 36px;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(78, 119, 153, .16);
  border-radius: 10px;
  color: #4e7799;
  background: #edf3f6;
  font-size: 1rem;
  transition: .18s ease;
}

.follow-header .back-btn:hover {
  color: #e95a13;
  background: #fff3ec;
  transform: translateX(-2px);
}

.follow-title-block { min-width: 0; flex: 1 1; }

.follow-title-kicker {
  display: block;
  margin-bottom: 2px;
  color: #71899b;
  font-size: .62rem;
  font-weight: 850;
  letter-spacing: .1em;
  text-transform: uppercase;
}

.follow-header h3 {
  margin: 0;
  color: #1d394f;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 1.05rem;
  font-weight: 850;
  letter-spacing: -.015em;
}

.follow-count {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  min-width: 32px;
  height: 32px;
  padding: 0 7px;
  border: 1px solid rgba(233, 90, 19, .2);
  border-radius: 10px;
  color: #d84f0d;
  background: #fff3ec;
  font-size: .75rem;
  font-weight: 850;
}

.follow-search-wrap {
  height: 44px;
  margin: 14px 16px 10px;
  padding: 0 12px;
  border: 1px solid rgba(78, 119, 153, .16);
  border-radius: 12px;
  background: #f1f5f7;
}

.follow-search-wrap:focus-within {
  border-color: #e95a13;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);
}

.follow-search-icon { color: #4e7799; opacity: 1; }

.follow-search {
  color: #29475e;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .82rem;
  font-weight: 600;
}

.follow-search::placeholder { color: #71899b; }

.follow-list {
  gap: 7px;
  padding: 6px 16px 18px;
  scrollbar-width: thin;
  scrollbar-color: #94a9ba transparent;
}

.follow-item {
  gap: 10px;
  padding: 10px;
  border: 1px solid transparent;
  border-radius: 13px;
  background: #ffffff;
  animation: follow-item-in .32s ease both;
}

.follow-item:nth-child(2) { animation-delay: .04s; }
.follow-item:nth-child(3) { animation-delay: .08s; }
.follow-item:nth-child(4) { animation-delay: .12s; }
.follow-item:nth-child(5) { animation-delay: .16s; }

.follow-item:hover {
  border-color: rgba(233, 90, 19, .22);
  background: #fff8f4;
  box-shadow: 0 8px 18px rgba(30, 63, 88, .07);
  transform: translateX(-2px);
}

.follow-item-left { min-width: 0; gap: 10px; }

.follow-avatar,
.follow-user-icon {
  width: 42px;
  height: 42px;
  padding: 0;
  border: 2px solid #ffffff;
  border-radius: 12px;
  background: #eaf0f4;
  box-shadow: 0 4px 10px rgba(30, 63, 88, .1);
}

.follow-user-icon { color: #4e7799; }

.follow-username {
  overflow: hidden;
  display: block;
  color: #29475e;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .82rem;
  font-weight: 800;
  letter-spacing: -.005em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.follow-btn {
  min-width: 80px;
  min-height: 32px;
  margin-left: 0;
  padding: 6px 10px;
  border: 1px solid #e95a13;
  border-radius: 9px;
  color: #ffffff;
  background: #e95a13;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .68rem;
  font-weight: 800;
  transition: .18s ease;
}

.follow-btn:hover {
  background: #d84f0d;
  box-shadow: 0 7px 14px rgba(233, 90, 19, .2);
  transform: translateY(-1px);
}

.follow-btn.following {
  border-color: rgba(78, 119, 153, .2);
  color: #4e7799;
  background: #edf3f6;
}

.follow-empty-state { color: #71899b; }

.follow-empty-icon {
  display: grid;
  place-items: center;
  width: 58px;
  height: 58px;
  margin-bottom: 12px;
  border: 1px solid rgba(233, 90, 19, .18);
  border-radius: 17px;
  background: #fff3ec;
  font-size: 1.55rem;
}

@keyframes follow-panel-in {
  from { opacity: 0; transform: translateX(28px) scale(.985); }
  to { opacity: 1; transform: translateX(0) scale(1); }
}

@keyframes follow-panel-out {
  to { opacity: 0; transform: translateX(28px) scale(.985); }
}

@keyframes follow-item-in {
  from { opacity: 0; transform: translateY(9px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 768px) {
  .follow-page-overlay { align-items: flex-end; padding: 0; }

  .follow-page {
    width: 100%;
    height: min(82vh, 680px);
    border-radius: 20px 20px 0 0;
    animation-name: follow-sheet-in;
  }

  .follow-page.closing { animation-name: follow-sheet-out; }

  .follow-header { min-height: 70px; padding: 17px 14px 12px; }

  .follow-list { padding: 5px 12px 16px; }
}

@keyframes follow-sheet-in {
  from { opacity: 0; transform: translateY(38px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes follow-sheet-out {
  to { opacity: 0; transform: translateY(38px); }
}

@media (max-width: 600px) {
  .profile-display-name {
    align-items: flex-start;
  }

  .profile-display-name h2,
  .profile-info .profile-display-name h2 {
    overflow: visible;
    margin: 0 0 5px;
    font-size: clamp(.78rem, 3.5vw, .96rem);
    line-height: 1.25;
    overflow-wrap: anywhere;
    text-overflow: clip;
    white-space: normal;
  }

  .profile-display-name .verified-badge {
    margin-top: 1px;
  }
}
.native-profile-menu-wrap,
.native-profile-tab-icon,
.native-profile-dock {
  display: none;
}
.profile-share-btn { display: inline-flex; align-items: center; justify-content: center; gap: 7px; }
.profile-share-overlay { position: fixed; z-index: 12000; inset: 0; display: grid; place-items: center; padding: 18px; background: rgba(8,25,38,.62); backdrop-filter: blur(8px); }
.profile-share-panel { width: min(100%, 480px); max-height: min(760px, 90vh); overflow: auto; padding: 22px; border: 1px solid rgba(233,90,19,.28); border-radius: 24px; background: #fff; box-shadow: 0 30px 80px rgba(7,29,43,.3); }
.profile-share-header { display: flex; align-items: center; justify-content: space-between; gap: 15px; }
.profile-share-header span { color: #e95a13; font-size: .62rem; font-weight: 900; letter-spacing: .15em; }
.profile-share-header h3 { margin: 4px 0 0; color: #17364b; font-size: 1.2rem; }
.profile-share-header button { display: grid; width: 38px; height: 38px; place-items: center; border: 0; border-radius: 12px; color: #17364b; background: #edf3f6; cursor: pointer; }
.profile-share-link { display: grid; grid-template-columns: 1fr auto auto; gap: 8px; align-items: center; margin-top: 18px; padding: 10px; border-radius: 15px; background: #f0f4f6; }
.profile-share-link > span { min-width: 0; overflow: hidden; color: #58758a; font-size: .72rem; text-overflow: ellipsis; white-space: nowrap; }
.profile-share-link button { display: inline-flex; min-height: 36px; align-items: center; gap: 5px; padding: 0 10px; border: 0; border-radius: 10px; color: #e95a13; background: #fff; font-size: .7rem; font-weight: 800; cursor: pointer; }
.profile-share-panel h4 { margin: 20px 0 8px; color: #17364b; font-size: .82rem; }
.profile-share-matches { display: grid; gap: 6px; max-height: 260px; overflow: auto; }
.profile-share-matches > p { color: #71899b; font-size: .78rem; }
.profile-share-matches > button { display: flex; min-height: 55px; align-items: center; gap: 10px; padding: 7px 10px; border: 1px solid #e0e9ee; border-radius: 13px; color: #17364b; background: #fff; font-weight: 800; cursor: pointer; }
.profile-share-matches > button.selected { border-color: #e95a13; background: #fff5ef; }
.profile-share-matches img, .profile-share-fallback { display: grid; width: 38px; height: 38px; flex: 0 0 38px; place-items: center; border-radius: 50%; object-fit: cover; color: #fff; background: #4e7799; }
.profile-share-matches button > span:nth-child(2) { flex: 1 1; overflow: hidden; text-align: left; text-overflow: ellipsis; }
.profile-share-matches i { display: grid; width: 24px; height: 24px; place-items: center; border-radius: 50%; color: #fff; background: #e95a13; font-style: normal; }
.profile-share-send { display: flex; width: 100%; min-height: 46px; align-items: center; justify-content: center; gap: 8px; margin-top: 14px; border: 0; border-radius: 13px; color: #fff; background: #e95a13; font-weight: 900; cursor: pointer; }
.profile-share-send:disabled { opacity: .4; cursor: default; }
.profile-share-feedback { margin: 12px 0 0; color: #168360; font-size: .76rem; font-weight: 800; text-align: center; }
@media (max-width: 600px) { .profile-share-overlay { align-items: end; padding: 0; } .profile-share-panel { width: 100%; max-height: 86vh; border-radius: 24px 24px 0 0; padding: 19px 15px 25px; } .profile-share-link { grid-template-columns: 1fr 1fr; } .profile-share-link > span { grid-column: 1 / -1; } .profile-share-link button { justify-content: center; } }
`, "",{"version":3,"sources":["webpack://./src/componentsL/SportProfile.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,sBAAsB;EACtB,iBAAiB;EACjB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;;AAEf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,eAAe;;EAEf,aAAa;EACb,mCAAmC;EACnC,8BAA8B;;EAE9B,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,+BAA+B;AACjC;;;AAGA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;;AAGA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE;;;kBAGgB;EAChB,0BAA0B;EAC1B,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;;EAER,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;;AAGA;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,WAAW;;AAEX;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;;;AAIA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;;AAGA,SAAS;;AAET;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,SAAS;;EAET,aAAa;;EAEb,mBAAmB;;EAEnB,qBAAqB;;EAErB,eAAe;AACjB;;AAEA;EACE,qCAAqC;;EAErC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET,SAAO;AACT;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;;EAEP,YAAY;EACZ,aAAa;;EAEb,uBAAuB;;;EAGvB,eAAe;AACjB;;;;AAIA;EACE,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;;EAElB,WAAW;;EAEX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;;;AAIA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;;AAGA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;;AAGA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;;;;AAKA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;;;;;AAMA,YAAY;;AAEZ;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET,YAAY;EACZ,aAAa;;EAEb,eAAe;;EAEf,kBAAkB;EAClB,mBAAmB;;EAEnB,mBAAmB;;EAEnB,qCAAqC;;EAErC,2BAA2B;;EAE3B,kBAAkB;;EAElB,0BAA0B;;EAE1B,gBAAgB;;EAEhB;kCACgC;;EAEhC,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;;EAE3B,qCAAqC;;EAErC;kCACgC;AAClC;;AAEA,UAAU;;AAEV;EACE,WAAW;EACX,YAAY;;EAEZ,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,iBAAiB;;EAEjB,qCAAqC;AACvC;;AAEA,SAAS;;AAET;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,WAAW;;AAEX;;EAEE;IACE,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;;IAEhB,kBAAkB;;IAElB,+BAA+B;IAC/B,gCAAgC;IAChC,yBAAyB;IACzB,0BAA0B;;IAE1B,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;;IAEZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;;;AAIA,UAAU;;;AAGV;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,iBAAiB;;EAEjB,mBAAmB;;EAEnB,qBAAqB;;EAErB,oCAAoC;;EAEpC,0CAA0C;;EAE1C,yBAAyB;;EAEzB,eAAe;;EAEf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;;;AAIA;;EAEE,kBAAkB;;EAElB,SAAS;EACT,WAAW;;EAEX,UAAU;;EAEV,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;;EAElB,8BAA8B;;EAE9B;cACY;;EAEZ,YAAY;;EAEZ,eAAe;;AAEjB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,sBAAsB;EACtB,gCAAgC;EAChC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR;;sBAEoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kEAAkE;EAClE;;;mCAGiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,qBAAqB,EAAE;AAC5C;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wCAAwC;IACxC,4CAA4C;IAC5C,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA,oEAAoE;AACpE;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,oEAAoE;AACtE;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,iEAAiE;AACnE;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,6BAA6B;EAC7B,SAAS;EACT,SAAS;EACT,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,yCAAyC;EACzC,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,QAAQ;EACR,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;;EAEE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qEAAqE;AACvE;;AAEA;EACE,OAAO,YAAY,EAAE;EACrB,KAAK,UAAU,EAAE;AACnB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;;EAErB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;IACb,mBAAmB;EACrB;;EAEA,yBAAyB,aAAa,EAAE;;EAExC;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,WAAW;IACX,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kEAAkE;EAClE,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,uBAAuB,iDAAiD,EAAE;;AAE1E;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,sBAAsB,YAAY,EAAE,SAAO,EAAE;;AAE7C;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,oEAAoE;EACpE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,sBAAsB,cAAc,EAAE,UAAU,EAAE;;AAElD;EACE,cAAc;EACd,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,8BAA8B,cAAc,EAAE;;AAE9C;EACE,QAAQ;EACR,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,4BAA4B,qBAAqB,EAAE;AACnD,4BAA4B,qBAAqB,EAAE;AACnD,4BAA4B,qBAAqB,EAAE;AACnD,4BAA4B,qBAAqB,EAAE;;AAEnD;EACE,oCAAoC;EACpC,mBAAmB;EACnB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA,oBAAoB,YAAY,EAAE,SAAS,EAAE;;AAE7C;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,oBAAoB,cAAc,EAAE;;AAEpC;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,mBAAmB;AACrB;;AAEA,sBAAsB,cAAc,EAAE;;AAEtC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,KAAK,UAAU,EAAE,uCAAuC,EAAE;AAC5D;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,uBAAuB,qBAAqB,EAAE,UAAU,EAAE;;EAE1D;IACE,WAAW;IACX,wBAAwB;IACxB,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA,uBAAuB,gCAAgC,EAAE;;EAEzD,iBAAiB,gBAAgB,EAAE,uBAAuB,EAAE;;EAE5D,eAAe,sBAAsB,EAAE;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,KAAK,UAAU,EAAE,2BAA2B,EAAE;AAChD;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;IACf,uCAAuC;IACvC,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;;;EAGE,aAAa;AACf;AACA,qBAAqB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;AACnG,yBAAyB,eAAe,EAAE,cAAc,EAAE,QAAQ,EAAE,aAAa,EAAE,mBAAmB,EAAE,aAAa,EAAE,6BAA6B,EAAE,0BAA0B,EAAE;AAClL,uBAAuB,uBAAuB,EAAE,4BAA4B,EAAE,cAAc,EAAE,aAAa,EAAE,qCAAqC,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,wCAAwC,EAAE;AACrO,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE;AACvG,6BAA6B,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACzG,2BAA2B,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC/E,+BAA+B,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACpL,sBAAsB,aAAa,EAAE,oCAAoC,EAAE,QAAQ,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AACrL,6BAA6B,YAAY,EAAE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC9I,6BAA6B,oBAAoB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,SAAS,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC5O,0BAA0B,kBAAkB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AACjF,yBAAyB,aAAa,EAAE,QAAQ,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACrF,6BAA6B,cAAc,EAAE,iBAAiB,EAAE;AAChE,kCAAkC,aAAa,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC3O,2CAA2C,qBAAqB,EAAE,mBAAmB,EAAE;AACvF,sDAAsD,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAC9M,oDAAoD,SAAO,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC1H,2BAA2B,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,WAAW,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACpK,sBAAsB,aAAa,EAAE,WAAW,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,SAAS,EAAE,mBAAmB,EAAE,WAAW,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACnP,+BAA+B,WAAW,EAAE,eAAe,EAAE;AAC7D,0BAA0B,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACrH,4BAA4B,yBAAyB,gBAAgB,EAAE,UAAU,EAAE,EAAE,uBAAuB,WAAW,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,uBAAuB,EAAE,EAAE,sBAAsB,8BAA8B,EAAE,EAAE,6BAA6B,mBAAmB,EAAE,EAAE,6BAA6B,uBAAuB,EAAE,EAAE","sourcesContent":[".profile-container {\n  max-width: 800px;\n  margin: auto;\n  /* background: var(--bg-100); */\n  color: var(--text-100);\n  min-height: 100vh;\n  font-family: system-ui, sans-serif;\n  padding-bottom: 80px;\n}\n\n.profile-header {\n  display: flex;\n  gap: 16px;\n  padding: 20px;\n\n}\n\n.profile-avatar {\n  width: 90px;\n  height: 90px;\n  border-radius: 50%;\n  border: 3px solid var(--primary-100);\n  object-fit: cover;\n}\n\n.main-profile-header {\n  margin-top: 20px;\n  background: var(--primary-300);\n  border-bottom: 1px solid var(--bg-200);\n}\n\n.profile-info h2 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.bio {\n  color: var(--text-200);\n  font-size: 13px;\n  margin-top: 4px;\n}\n\n\n.stats {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.stats div {\n  /* text-align: center; */\n  display: flex;\n  flex-direction: column;\n}\n\n.stats strong {\n  font-size: 14px;\n  color: var(--primary-200);\n}\n\n.stats span {\n  display: block;\n  font-size: 13px;\n  /* margin-left: 5px; */\n  color: var(--text-200);\n}\n\n\n.cta-buttons {\n  display: flex;\n  gap: 10px;\n  padding: 0 20px;\n  margin-top: 10px;\n}\n\n.btn {\n  flex: 1;\n  padding: 10px;\n  border-radius: 10px;\n  border: none;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.primary {\n  background: var(--primary-100);\n  color: var(--primary-300);\n}\n\n.btn.primary {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 3px;\n}\n\n.btn.secondary {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 3px;\n}\n\n.secondary {\n  background: transparent;\n  border: 1px solid var(--primary-200);\n  color: var(--primary-200);\n}\n\n.insights {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n  padding: 20px;\n}\n\n.insight-card {\n  background: var(--primary-300);\n  padding: 12px;\n  border-radius: 14px;\n  text-align: center;\n  font-size: 12px;\n  border: 1px solid var(--bg-200);\n  display: flex;\n  gap: 4px;\n}\n\n.insight-card svg {\n  font-size: 18px;\n  margin-bottom: 6px;\n  color: var(--primary-100);\n}\n\n.insight-card span {\n  color: var(--text-200);\n}\n\n.tabs {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  /* top: 50px; */\n\n  display: flex;\n  border-top: 1px solid var(--bg-200);\n  background: var(--primary-300);\n\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.tabs button {\n  flex: 1;\n  padding: 12px;\n  background: none;\n  border: none;\n  color: var(--text-200);\n  font-weight: 600;\n}\n\n.tabs .active {\n  color: var(--primary-100);\n  border-bottom: 3px solid var(--primary-100);\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2px;\n}\n\n.grid-item {\n  aspect-ratio: 1 / 1;\n  background: var(--bg-200);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--primary-300);\n  font-size: 18px;\n  position: relative;\n  overflow: hidden;\n}\n\n.grid-item img {\n  width: 100%;\n  object-fit: cover;\n}\n\n.grid,\n.reels-grid {\n  position: relative;\n  min-height: calc(100vh - 320px);\n}\n\n\n.reels-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 4px;\n}\n\n.reel-item {\n  position: relative;\n  aspect-ratio: 9/16;\n  overflow: hidden;\n  border-radius: 6px;\n  background: black;\n}\n\n.reel-item video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n\n@media (max-width: 768px) {\n  .profile-container {\n    max-width: 100%;\n  }\n\n  .profile-header {\n    padding-top: 20px;\n  }\n\n  .empty-state {\n    width: 100%;\n  }\n}\n\n\n.profile-top-bar {\n  max-width: 1000px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 auto;\n  padding: 12px 16px;\n  /* background: var(--bg-100); */\n  border-bottom: 1px solid var(--bg-200);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.back-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.top-actions {\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.profile-bio {\n  font-size: 14px;\n  color: var(--text-200);\n  max-width: 420px;\n  padding: 15px;\n}\n\n.text-posts {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  margin-top: 20px;\n  padding: 0 10px;\n  position: relative;\n  min-height: calc(100vh - 320px);\n}\n\n.text-post-card {\n  background: white;\n  padding: 18px;\n  border-radius: 14px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);\n  transition: 0.2s;\n}\n\n.text-post-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);\n}\n\n.text-post-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.text-post-header img {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.text-post-header strong {\n  font-size: 14px;\n  display: block;\n}\n\n.post-date {\n  font-size: 12px;\n  color: var(--text-200);\n}\n\n.text-post-content {\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--text-100);\n  margin-top: 8px;\n  white-space: pre-line;\n}\n\n.text-post-actions {\n  display: flex;\n  gap: 20px;\n  margin-top: 12px;\n  font-size: 14px;\n  color: var(--text-200);\n}\n\n.text-post-actions span {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  cursor: pointer;\n}\n\n.post-viewer-overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: flex-end;\n  z-index: 999;\n}\n\n.post-viewer {\n  width: 420px;\n  height: 100%;\n  background: white;\n  overflow-y: auto;\n  animation: slideViewer .25s ease;\n  padding: 20px;\n}\n\n@keyframes slideViewer {\n  from {\n    transform: translateX(100%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n}\n\n.viewer-close {\n  position: sticky;\n  top: 0;\n  background: white;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n\n\n.skeleton {\n  background: linear-gradient(90deg,\n      #f0f0f0 25%,\n      #e4e4e4 37%,\n      #f0f0f0 63%);\n  background-size: 400% 100%;\n  animation: skeleton-loading 1.4s ease infinite;\n  border-radius: 8px;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 100% 50%;\n  }\n\n  100% {\n    background-position: 0 50%;\n  }\n}\n\n\n.skeleton-avatar {\n  width: 90px;\n  height: 90px;\n  border-radius: 50%;\n}\n\n\n.grid-skeleton {\n  width: 100%;\n  aspect-ratio: 1/1;\n  border-radius: 6px;\n}\n\n\n.text-post-skeleton {\n  padding: 15px;\n  border: 1px solid #eee;\n  border-radius: 12px;\n  margin-bottom: 15px;\n}\n\n.empty-state {\n  position: absolute;\n  inset: 0;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  text-align: center;\n  color: #888;\n}\n\n.empty-state svg {\n  margin-bottom: 10px;\n  opacity: 0.6;\n}\n\n.empty-state h4 {\n  font-size: 18px;\n  margin-bottom: 5px;\n}\n\n.empty-state p {\n  font-size: 14px;\n}\n\n\n.follow-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.follow-modal {\n  width: 350px;\n  max-height: 500px;\n  background: white;\n  border-radius: 12px;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n}\n\n.follow-search {\n  padding: 8px;\n  border-radius: 20px;\n  border: 1px solid #ddd;\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n\n.follow-list {\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.follow-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n\n.follow-user-icon {\n  background-color: var(--primary-200);\n  padding: 10px;\n  border-radius: 50%;\n  width: 35px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.flw-icon {}\n\n.follow-item:hover {\n  background: #f5f5f5;\n  border-radius: 8px;\n}\n\n.follow-avatar {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n\n\n.follow-search-wrap {\n  margin: 16px;\n  height: 48px;\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.06);\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n  gap: 12px;\n  border: 1px solid transparent;\n  transition: .2s ease;\n}\n\n.follow-search-wrap:focus-within {\n  border-color: rgba(255, 255, 255, 0.16);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n\n/* ITEM */\n\n.follow-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  gap: 14px;\n\n  padding: 12px;\n\n  border-radius: 20px;\n\n  transition: .22s ease;\n\n  cursor: pointer;\n}\n\n.follow-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n\n  transform: translateY(-1px);\n}\n\n.follow-item-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n\n  flex: 1;\n}\n\n.follow-search-icon {\n  opacity: .6;\n  font-size: 14px;\n}\n\n.follow-search {\n  flex: 1;\n\n  border: none;\n  outline: none;\n\n  background: transparent;\n\n\n  font-size: 14px;\n}\n\n\n\n.follow-empty-state {\n  height: 100%;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  text-align: center;\n\n  opacity: .9;\n\n  padding: 30px;\n}\n\n.follow-empty-icon {\n  font-size: 48px;\n  margin-bottom: 14px;\n}\n\n.follow-empty-state h4 {\n  font-size: 18px;\n  margin-bottom: 8px;\n}\n\n.follow-empty-state p {\n  opacity: .65;\n  max-width: 260px;\n  line-height: 1.5;\n}\n\n\n\n.follow-btn {\n  margin-left: auto;\n  padding: 5px 10px;\n  border-radius: 20px;\n  border: none;\n  cursor: pointer;\n  background: var(--primary-200);\n  color: white;\n  font-size: 12px;\n}\n\n.follow-btn.following {\n  background: #eee;\n  color: black;\n}\n\n\n.follow-page-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.2);\n  z-index: 999;\n}\n\n.follow-page {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  max-width: 400px;\n  height: 100%;\n  background: white;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  animation: slideInRight 0.3s ease;\n}\n\n.follow-page.closing {\n  animation: slideOutRight 0.3s ease;\n}\n\n\n.follow-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 15px;\n  border-bottom: 1px solid #eee;\n}\n\n.follow-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px;\n}\n\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideOutRight {\n  from {\n    transform: translateX(0);\n  }\n\n  to {\n    transform: translateX(100%);\n  }\n}\n\n\n\n\n.highlights-section {\n  width: 92%;\n  margin: 20px auto;\n}\n\n.highlights-section h3 {\n  font-size: 18px;\n  margin-bottom: 12px;\n  font-weight: 700;\n  color: #111;\n}\n\n.highlights-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.highlight-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: white;\n  border: 1px solid #ececec;\n  padding: 14px 16px;\n  border-radius: 14px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, .04);\n  transition: .2s;\n}\n\n.highlight-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, .08);\n}\n\n.highlight-dot {\n  width: 10px;\n  height: 10px;\n  min-width: 10px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ff5f6d, #ffc371);\n}\n\n.highlight-card p {\n  margin: 0;\n  font-size: 14px;\n  color: #222;\n  line-height: 1.5;\n}\n\n.no-highlights {\n  color: #888;\n  text-align: center;\n  padding: 20px;\n  background: #fafafa;\n  border-radius: 14px;\n}\n\n.skeleton-highlight {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.skeleton-dot {\n  width: 10px;\n  height: 10px;\n  min-width: 10px;\n  border-radius: 50%;\n}\n\n\n\n\n\n/* TOP BAR */\n\n.sport-profile-topbar {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n}\n\n/* BUTTON */\n\n.sport-back-btn {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n\n  border: none;\n  outline: none;\n\n  cursor: pointer;\n\n  padding: 14px 18px;\n  margin-bottom: 10px;\n\n  border-radius: 22px;\n\n  background: rgba(255, 255, 255, 0.08);\n\n  backdrop-filter: blur(12px);\n\n  /* color: white; */\n\n  transition: all 0.25s ease;\n\n  min-width: 220px;\n\n  box-shadow:\n    0 4px 18px rgba(0, 0, 0, 0.12);\n\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  color: var(--primary-200);\n}\n\n.sport-back-btn:hover {\n  transform: translateY(-2px);\n\n  background: rgba(255, 255, 255, 0.12);\n\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.18);\n}\n\n/* ARROW */\n\n.back-arrow {\n  width: 42px;\n  height: 42px;\n\n  border-radius: 50%;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 20px;\n  font-weight: bold;\n\n  background: rgba(255, 255, 255, 0.12);\n}\n\n/* TEXT */\n\n.back-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.back-label {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.back-content small {\n  opacity: 0.7;\n  font-size: 12px;\n}\n\n/* MOBILE */\n\n@media (max-width: 768px) {\n\n  .sport-profile-topbar {\n    /* margin-bottom: 12px; */\n    margin-top: 0;\n  }\n\n  .sport-back-btn {\n    width: 100%;\n    min-width: unset;\n\n    padding: 12px 14px;\n\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n\n    /* border-radius: 18px; */\n  }\n\n  .back-arrow {\n    width: 36px;\n    height: 36px;\n\n    font-size: 18px;\n  }\n\n  .back-label {\n    font-size: 14px;\n  }\n\n  .back-content small {\n    font-size: 11px;\n  }\n}\n\n\n\n/* links */\n\n\n.profile-links-section {\n  margin-top: 10px;\n}\n\n.profile-links-title {\n  margin-bottom: 12px;\n  font-size: 15px;\n  font-weight: 700;\n  margin-left: 20px;\n}\n\n.profile-links {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-left: 20px;\n\n}\n\n.profile-link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  padding: 5px 10px;\n\n  border-radius: 12px;\n\n  text-decoration: none;\n\n  background: rgba(255, 255, 255, .04);\n\n  border: 1px solid rgba(255, 255, 255, .08);\n\n  color: var(--primary-200);\n\n  transition: .3s;\n\n  word-break: break-all;\n}\n\n.profile-link:hover {\n  transform: translateY(-2px);\n  color: var(--primary-100);\n}\n\n\n\n.pinned-badge {\n\n  position: absolute;\n\n  top: 10px;\n  right: 10px;\n\n  z-index: 5;\n\n  width: 30px;\n  height: 30px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 50%;\n\n  background: var(--primary-100);\n\n  backdrop-filter:\n    blur(10px);\n\n  color: white;\n\n  font-size: 14px;\n\n}\n\n\n.photo-wow {\n  width: 90px;\n  height: 90px;\n  min-width: 90px;\n  min-height: 90px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n  border: 3px solid var(--primary-100);\n}\n\n.photo-wow img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.profile-display-name {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n}\n\n.profile-display-name h2 {\n  min-width: 0;\n}\n\n.photo-wow-clickable {\n  position: relative;\n  cursor: zoom-in;\n  transition: transform .2s ease, box-shadow .2s ease;\n}\n\n.photo-wow-clickable::after {\n  content: \"\";\n  position: absolute;\n  inset: 3px;\n  border-radius: inherit;\n  background: rgba(2, 6, 23, 0);\n  transition: background .2s ease;\n}\n\n.photo-wow-clickable:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 28px rgba(233, 90, 19, .24);\n}\n\n.photo-wow-clickable:hover::after {\n  background: rgba(2, 6, 23, .1);\n}\n\n.photo-wow-clickable:focus-visible {\n  outline: 3px solid rgba(233, 90, 19, .3);\n  outline-offset: 4px;\n}\n\n.profile-photo-viewer {\n  position: fixed;\n  inset: 0;\n  z-index: 12000;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  padding: 32px;\n  background: rgba(2, 6, 23, .76);\n  animation: profile-photo-viewer-in .24s ease both;\n  isolation: isolate;\n}\n\n.profile-photo-viewer-backdrop {\n  position: absolute;\n  z-index: -2;\n  inset: -60px;\n  background-position: center;\n  background-size: cover;\n  filter: blur(42px) saturate(.85);\n  opacity: .55;\n  transform: scale(1.12);\n}\n\n.profile-photo-viewer::after {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  inset: 0;\n  background:\n    radial-gradient(circle at center, rgba(15, 23, 42, .12), rgba(2, 6, 23, .72) 72%),\n    rgba(2, 6, 23, .3);\n  backdrop-filter: blur(10px);\n}\n\n.profile-photo-viewer-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 100%;\n  animation: profile-photo-content-in .38s cubic-bezier(.2, .85, .25, 1.15) both;\n}\n\n.profile-photo-viewer-ring {\n  width: min(58vw, 470px);\n  aspect-ratio: 1;\n  padding: 7px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #f97316, #e95a13 44%, #fbbf24);\n  box-shadow:\n    0 0 0 6px rgba(255, 255, 255, .1),\n    0 28px 80px rgba(0, 0, 0, .55),\n    0 0 70px rgba(233, 90, 19, .25);\n}\n\n.profile-photo-viewer-ring img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: 5px solid #fff;\n  border-radius: 50%;\n  object-fit: cover;\n  background: #eaf0f4;\n}\n\n.profile-photo-viewer-content p {\n  max-width: min(80vw, 480px);\n  overflow: hidden;\n  margin: 24px 0 0;\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 800;\n  letter-spacing: .01em;\n  text-overflow: ellipsis;\n  text-shadow: 0 2px 14px rgba(0, 0, 0, .7);\n  white-space: nowrap;\n}\n\n.profile-photo-viewer-close {\n  position: absolute;\n  top: max(22px, env(safe-area-inset-top));\n  right: max(22px, env(safe-area-inset-right));\n  display: grid;\n  place-items: center;\n  width: 46px;\n  height: 46px;\n  padding: 0;\n  border: 1px solid rgba(255, 255, 255, .24);\n  border-radius: 50%;\n  color: #fff;\n  background: rgba(15, 23, 42, .5);\n  backdrop-filter: blur(14px);\n  cursor: pointer;\n  font-size: 19px;\n  transition: transform .2s ease, background .2s ease;\n}\n\n.profile-photo-viewer-close:hover {\n  background: rgba(233, 90, 19, .78);\n  transform: rotate(8deg) scale(1.05);\n}\n\n@keyframes profile-photo-viewer-in {\n  from { opacity: 0; }\n}\n\n@keyframes profile-photo-content-in {\n  from { opacity: 0; transform: scale(.78); }\n}\n\n@media (max-width: 600px) {\n  .profile-photo-viewer {\n    padding: 22px;\n  }\n\n  .profile-photo-viewer-ring {\n    width: min(82vw, 360px);\n    padding: 5px;\n  }\n\n  .profile-photo-viewer-ring img {\n    border-width: 4px;\n  }\n\n  .profile-photo-viewer-close {\n    top: max(16px, env(safe-area-inset-top));\n    right: max(16px, env(safe-area-inset-right));\n    width: 42px;\n    height: 42px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .profile-photo-viewer,\n  .profile-photo-viewer-content {\n    animation: none;\n  }\n}\n\n/* Futuristic profile surface: dense information, calm technology. */\n.pro-profile-container {\n  min-height: 100vh;\n  padding: 24px;\n  background: #f4f7f8;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n}\n\n.profile-container {\n  max-width: 1180px;\n  margin: 0 auto;\n  padding-bottom: 46px;\n  color: #1d394f;\n}\n\n.sport-profile-topbar {\n  justify-content: flex-start;\n  /* margin: 0 0 18px; */\n}\n\n.sport-back-btn {\n  width: fit-content;\n  max-width: 100%;\n  min-width: 0;\n  padding: 10px 14px;\n  border: 1px solid rgba(78, 119, 153, .18);\n  /* border-radius: 14px; */\n  color: #345269;\n  background: #fbfcfd;\n  box-shadow: 0 8px 20px rgba(30, 63, 88, .07), inset 0 1px #ffffff;\n}\n\n.sport-back-btn:hover {\n  color: #d84f0d;\n  background: #fff8f4;\n  box-shadow: 0 11px 24px rgba(30, 63, 88, .1);\n}\n\n.back-arrow {\n  width: 34px;\n  height: 34px;\n  color: #e95a13;\n  background: #fff3ec;\n  font-size: 17px;\n}\n\n.back-label {\n  font-size: .82rem;\n  font-weight: 800;\n  letter-spacing: .005em;\n}\n\n.back-content small {\n  color: #71899b;\n  font-size: .68rem;\n  opacity: 1;\n}\n\n.main-profile-header {\n  display: grid;\n  grid-template-columns: minmax(0, 1.45fr) minmax(280px, .75fr);\n  grid-template-rows: auto auto;\n  gap: 16px;\n  margin: 0;\n  padding: 20px;\n  border: 1px solid rgba(78, 119, 153, .16);\n  border-radius: 22px;\n  background: #fbfcfd;\n  box-shadow: 0 18px 40px rgba(30, 63, 88, .08), inset 0 1px #ffffff;\n}\n\n.main-profile-header::before {\n  content: \"\";\n  grid-column: 1 / -1;\n  height: 2px;\n  margin: -20px 28px 0;\n  border-radius: 0 0 3px 3px;\n  background: #e95a13;\n}\n\n.profile-header {\n  grid-row: 2 / span 2;\n  align-items: flex-start;\n  gap: 18px;\n  min-height: 156px;\n  padding: 18px;\n  border: 1px solid rgba(78, 119, 153, .13);\n  border-radius: 17px;\n  background: #ffffff;\n}\n\n.photo-wow {\n  width: 104px;\n  height: 104px;\n  min-width: 104px;\n  min-height: 104px;\n  padding: 0;\n  border: 2px solid #e95a13;\n  border-radius: 19px;\n  background: transparent;\n  box-shadow: 0 10px 22px rgba(233, 90, 19, .17);\n}\n\n.photo-wow img {\n  width: 100%;\n  height: 100%;\n  border-radius: 16px;\n  object-fit: cover;\n}\n\n.profile-info {\n  min-width: 0;\n  flex: 1;\n}\n\n.profile-info h2 {\n  overflow: hidden;\n  margin: 4px 0 5px;\n  color: #1d394f;\n  font-size: 1.4rem;\n  font-weight: 850;\n  letter-spacing: -.02em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.bio {\n  display: inline-flex;\n  margin: 0;\n  padding: 5px 9px;\n  border: 1px solid rgba(78, 119, 153, .14);\n  border-radius: 999px;\n  color: #4e7799;\n  background: #edf3f6;\n  font-size: .73rem;\n  font-weight: 750;\n  letter-spacing: .01em;\n  text-transform: capitalize;\n}\n\n.stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 20px;\n}\n\n.stats div {\n  min-width: 0;\n  padding: 10px;\n  border: 1px solid rgba(78, 119, 153, .12);\n  border-radius: 12px;\n  background: #f6f9fa;\n  transition: .18s ease;\n}\n\n.stats div:hover {\n  border-color: rgba(233, 90, 19, .25);\n  background: #fff8f4;\n  transform: translateY(-2px);\n}\n\n.stats strong {\n  color: #e95a13;\n  font-size: 1rem;\n  font-weight: 850;\n}\n\n.stats span {\n  overflow: hidden;\n  margin-top: 3px;\n  color: #71899b;\n  font-size: .67rem;\n  font-weight: 650;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.profile-summary,\n.profile-links-section {\n  padding: 16px;\n  border: 1px solid rgba(78, 119, 153, .13);\n  border-radius: 17px;\n  background: #ffffff;\n}\n\n.profile-summary {\n  min-height: 62px;\n}\n\n.profile-summary-empty {\n  border-color: transparent;\n  background: transparent;\n  box-shadow: none;\n}\n\n.profile-bio {\n  max-width: none;\n  margin: 0;\n  padding: 0;\n  color: #345269;\n  font-size: .83rem;\n  font-weight: 500;\n  line-height: 1.65;\n}\n\n.profile-links-section {\n  margin-top: 0;\n}\n\n.profile-links-title {\n  margin: 0 0 10px;\n  color: #29475e;\n  font-size: .76rem;\n  font-weight: 850;\n  letter-spacing: .07em;\n  text-transform: uppercase;\n}\n\n.profile-links {\n  gap: 7px;\n  margin: 0;\n}\n\n.profile-link {\n  padding: 8px 10px;\n  border: 1px solid rgba(78, 119, 153, .13);\n  border-radius: 10px;\n  color: #4e7799;\n  background: #f4f8fa;\n  font-size: .73rem;\n  font-weight: 650;\n}\n\n.profile-link:hover {\n  border-color: rgba(233, 90, 19, .25);\n  color: #d84f0d;\n  background: #fff3ec;\n}\n\n.cta-buttons {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  width: 100%;\n  gap: 9px;\n  margin: 14px 0 0;\n  padding: 0;\n}\n\n.cta-buttons .btn {\n  min-width: 0;\n  width: 100%;\n  min-height: 42px;\n  padding: 9px 16px;\n  border-radius: 11px;\n  font-family: inherit;\n  font-size: .78rem;\n  font-weight: 800;\n  transition: .18s ease;\n}\n\n.cta-buttons .profile-edit-btn {\n  width: 100%;\n}\n\n.cta-buttons .primary {\n  border: 1px solid #e95a13;\n  background: #e95a13;\n  box-shadow: 0 8px 18px rgba(233, 90, 19, .18);\n}\n\n.cta-buttons .primary:hover {\n  background: #d84f0d;\n  transform: translateY(-1px);\n}\n\n.cta-buttons .secondary {\n  border-color: rgba(78, 119, 153, .26);\n  color: #4e7799;\n  background: #ffffff;\n}\n\n.cta-buttons .secondary:hover {\n  border-color: rgba(233, 90, 19, .3);\n  color: #d84f0d;\n  background: #fff3ec;\n}\n\n.highlights-section {\n  width: auto;\n  margin: 16px 0;\n}\n\n.highlights-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n  gap: 10px;\n}\n\n.highlight-card {\n  min-height: 48px;\n  padding: 12px 14px;\n  border-color: rgba(78, 119, 153, .14);\n  border-radius: 13px;\n  box-shadow: 0 7px 17px rgba(30, 63, 88, .05);\n}\n\n.highlight-card:hover {\n  border-color: rgba(233, 90, 19, .25);\n  box-shadow: 0 10px 21px rgba(30, 63, 88, .08);\n}\n\n.highlight-dot {\n  background: #e95a13;\n  box-shadow: 0 0 0 4px rgba(233, 90, 19, .12);\n}\n\n.highlight-card p {\n  color: #345269;\n  font-size: .78rem;\n  font-weight: 600;\n}\n\n.tabs {\n  top: 76px;\n  gap: 5px;\n  margin-top: 20px;\n  padding: 6px;\n  border: 1px solid rgba(78, 119, 153, .16);\n  border-radius: 14px;\n  background: #fbfcfd;\n  box-shadow: 0 8px 20px rgba(30, 63, 88, .06);\n}\n\n.tabs button {\n  padding: 10px;\n  border-radius: 9px;\n  color: #71899b;\n  font-family: inherit;\n  font-size: .76rem;\n  font-weight: 800;\n  letter-spacing: .02em;\n  transition: .18s ease;\n}\n\n.tabs button:hover {\n  color: #d84f0d;\n  background: #fff3ec;\n}\n\n.tabs .active {\n  border: 0;\n  color: #e95a13;\n  background: #fff3ec;\n  box-shadow: inset 0 0 0 1px rgba(233, 90, 19, .14);\n}\n\n.grid,\n.reels-grid {\n  gap: 10px;\n  min-height: 280px;\n  margin-top: 14px;\n}\n\n.grid-item {\n  border: 1px solid rgba(78, 119, 153, .14);\n  border-radius: 14px;\n  background: #eaf0f4;\n  transition: .2s ease;\n}\n\n.grid-item:hover {\n  border-color: rgba(233, 90, 19, .4);\n  box-shadow: 0 11px 24px rgba(30, 63, 88, .13);\n  transform: translateY(-2px);\n}\n\n.grid-item img {\n  height: 100%;\n}\n\n.reel-item {\n  border: 1px solid rgba(78, 119, 153, .14);\n  border-radius: 14px;\n}\n\n.pinned-badge {\n  top: 9px;\n  right: 9px;\n  width: 32px;\n  height: 32px;\n  background: #e95a13;\n  box-shadow: 0 6px 13px rgba(233, 90, 19, .25);\n}\n\n.text-posts {\n  gap: 12px;\n  margin-top: 14px;\n  padding: 0;\n  min-height: 280px;\n}\n\n.text-post-card {\n  padding: 16px;\n  border: 1px solid rgba(78, 119, 153, .14);\n  border-radius: 16px;\n  box-shadow: 0 8px 20px rgba(30, 63, 88, .06);\n}\n\n.text-post-content {\n  color: #345269;\n  font-size: .88rem;\n}\n\n.skeleton {\n  background: #eaf0f4;\n  animation: profile-skeleton-pulse 1.2s ease-in-out infinite alternate;\n}\n\n@keyframes profile-skeleton-pulse {\n  from { opacity: .55; }\n  to { opacity: 1; }\n}\n\n.profile-container button:focus-visible,\n.profile-container a:focus-visible {\n  outline: 2px solid #e95a13;\n  outline-offset: 2px;\n}\n\n@media (max-width: 768px) {\n  .pro-profile-container {\n    padding: 0 10px 84px;\n  }\n\n  .profile-container {\n    padding-bottom: 0;\n  }\n\n  .sport-profile-topbar {\n    margin-bottom: 10px;\n\n  }\n\n  .sport-back-btn {\n    width: 100%;\n    /* border-radius: 14px; */\n  }\n\n  .main-profile-header {\n    display: flex;\n    flex-direction: column;\n    gap: 11px;\n    padding: 12px;\n    border-radius: 17px;\n  }\n\n  .main-profile-header::before {\n    width: calc(100% - 40px);\n    margin: -12px auto 0;\n  }\n\n  .profile-header {\n    min-height: 0;\n    gap: 12px;\n    padding: 13px;\n    border-radius: 13px;\n  }\n\n  .photo-wow {\n    width: 74px;\n    height: 74px;\n    min-width: 74px;\n    min-height: 74px;\n    border-radius: 15px;\n  }\n\n  .photo-wow img {\n    border-radius: 12px;\n  }\n\n  .profile-info h2 {\n    margin-top: 0;\n    font-size: 1.08rem;\n  }\n\n  .bio {\n    font-size: .65rem;\n  }\n\n  .stats {\n    gap: 5px;\n    margin-top: 13px;\n  }\n\n  .stats div {\n    padding: 8px 6px;\n    border-radius: 9px;\n  }\n\n  .stats strong {\n    font-size: .84rem;\n  }\n\n  .stats span {\n    font-size: .58rem;\n  }\n\n  .profile-summary,\n  .profile-links-section {\n    padding: 13px;\n    border-radius: 13px;\n  }\n\n  .profile-summary-empty { display: none; }\n\n  .profile-bio {\n    font-size: .77rem;\n  }\n\n  .cta-buttons {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    width: 100%;\n    gap: 7px;\n    margin-top: 12px;\n  }\n\n  .cta-buttons .btn {\n    min-width: 0;\n    width: 100%;\n    min-height: 40px;\n    padding: 8px 9px;\n    font-size: .7rem;\n    white-space: nowrap;\n  }\n\n  .cta-buttons .profile-edit-btn {\n    width: 100%;\n  }\n\n  .highlights-list {\n    grid-template-columns: 1fr;\n  }\n\n  .tabs {\n    top: 76px;\n    margin-top: 14px;\n    border-radius: 12px;\n  }\n\n  .tabs button {\n    padding: 9px 4px;\n    font-size: .64rem;\n  }\n\n  .grid,\n  .reels-grid {\n    gap: 5px;\n    margin-top: 10px;\n  }\n\n  .grid-item,\n  .reel-item {\n    border-radius: 9px;\n  }\n}\n\n/* Followers / following: animated CarrerUp network panel. */\n.follow-page-overlay {\n  display: flex;\n  justify-content: flex-end;\n  padding: 12px;\n  background: rgba(20, 43, 61, .48);\n  backdrop-filter: blur(12px);\n}\n\n.follow-page {\n  position: relative;\n  top: auto;\n  right: auto;\n  width: min(100%, 440px);\n  max-width: none;\n  height: 100%;\n  overflow: hidden;\n  border: 1px solid rgba(148, 169, 186, .38);\n  border-radius: 22px;\n  color: #1d394f;\n  background: #fbfcfd;\n  box-shadow: 0 28px 72px rgba(12, 31, 47, .32), inset 0 1px #ffffff;\n  animation: follow-panel-in .35s cubic-bezier(.2, .8, .2, 1);\n}\n\n.follow-page::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 34px;\n  left: 34px;\n  height: 3px;\n  border-radius: 0 0 4px 4px;\n  background: #e95a13;\n}\n\n.follow-page.closing { animation: follow-panel-out .25s ease-in forwards; }\n\n.follow-header {\n  min-height: 76px;\n  gap: 11px;\n  padding: 18px 18px 14px;\n  border-bottom: 1px solid rgba(78, 119, 153, .14);\n}\n\n.follow-header .back-btn {\n  display: grid;\n  flex: 0 0 auto;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(78, 119, 153, .16);\n  border-radius: 10px;\n  color: #4e7799;\n  background: #edf3f6;\n  font-size: 1rem;\n  transition: .18s ease;\n}\n\n.follow-header .back-btn:hover {\n  color: #e95a13;\n  background: #fff3ec;\n  transform: translateX(-2px);\n}\n\n.follow-title-block { min-width: 0; flex: 1; }\n\n.follow-title-kicker {\n  display: block;\n  margin-bottom: 2px;\n  color: #71899b;\n  font-size: .62rem;\n  font-weight: 850;\n  letter-spacing: .1em;\n  text-transform: uppercase;\n}\n\n.follow-header h3 {\n  margin: 0;\n  color: #1d394f;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: 1.05rem;\n  font-weight: 850;\n  letter-spacing: -.015em;\n}\n\n.follow-count {\n  display: grid;\n  flex: 0 0 auto;\n  place-items: center;\n  min-width: 32px;\n  height: 32px;\n  padding: 0 7px;\n  border: 1px solid rgba(233, 90, 19, .2);\n  border-radius: 10px;\n  color: #d84f0d;\n  background: #fff3ec;\n  font-size: .75rem;\n  font-weight: 850;\n}\n\n.follow-search-wrap {\n  height: 44px;\n  margin: 14px 16px 10px;\n  padding: 0 12px;\n  border: 1px solid rgba(78, 119, 153, .16);\n  border-radius: 12px;\n  background: #f1f5f7;\n}\n\n.follow-search-wrap:focus-within {\n  border-color: #e95a13;\n  background: #ffffff;\n  box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);\n}\n\n.follow-search-icon { color: #4e7799; opacity: 1; }\n\n.follow-search {\n  color: #29475e;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .82rem;\n  font-weight: 600;\n}\n\n.follow-search::placeholder { color: #71899b; }\n\n.follow-list {\n  gap: 7px;\n  padding: 6px 16px 18px;\n  scrollbar-width: thin;\n  scrollbar-color: #94a9ba transparent;\n}\n\n.follow-item {\n  gap: 10px;\n  padding: 10px;\n  border: 1px solid transparent;\n  border-radius: 13px;\n  background: #ffffff;\n  animation: follow-item-in .32s ease both;\n}\n\n.follow-item:nth-child(2) { animation-delay: .04s; }\n.follow-item:nth-child(3) { animation-delay: .08s; }\n.follow-item:nth-child(4) { animation-delay: .12s; }\n.follow-item:nth-child(5) { animation-delay: .16s; }\n\n.follow-item:hover {\n  border-color: rgba(233, 90, 19, .22);\n  background: #fff8f4;\n  box-shadow: 0 8px 18px rgba(30, 63, 88, .07);\n  transform: translateX(-2px);\n}\n\n.follow-item-left { min-width: 0; gap: 10px; }\n\n.follow-avatar,\n.follow-user-icon {\n  width: 42px;\n  height: 42px;\n  padding: 0;\n  border: 2px solid #ffffff;\n  border-radius: 12px;\n  background: #eaf0f4;\n  box-shadow: 0 4px 10px rgba(30, 63, 88, .1);\n}\n\n.follow-user-icon { color: #4e7799; }\n\n.follow-username {\n  overflow: hidden;\n  display: block;\n  color: #29475e;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .82rem;\n  font-weight: 800;\n  letter-spacing: -.005em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.follow-btn {\n  min-width: 80px;\n  min-height: 32px;\n  margin-left: 0;\n  padding: 6px 10px;\n  border: 1px solid #e95a13;\n  border-radius: 9px;\n  color: #ffffff;\n  background: #e95a13;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .68rem;\n  font-weight: 800;\n  transition: .18s ease;\n}\n\n.follow-btn:hover {\n  background: #d84f0d;\n  box-shadow: 0 7px 14px rgba(233, 90, 19, .2);\n  transform: translateY(-1px);\n}\n\n.follow-btn.following {\n  border-color: rgba(78, 119, 153, .2);\n  color: #4e7799;\n  background: #edf3f6;\n}\n\n.follow-empty-state { color: #71899b; }\n\n.follow-empty-icon {\n  display: grid;\n  place-items: center;\n  width: 58px;\n  height: 58px;\n  margin-bottom: 12px;\n  border: 1px solid rgba(233, 90, 19, .18);\n  border-radius: 17px;\n  background: #fff3ec;\n  font-size: 1.55rem;\n}\n\n@keyframes follow-panel-in {\n  from { opacity: 0; transform: translateX(28px) scale(.985); }\n  to { opacity: 1; transform: translateX(0) scale(1); }\n}\n\n@keyframes follow-panel-out {\n  to { opacity: 0; transform: translateX(28px) scale(.985); }\n}\n\n@keyframes follow-item-in {\n  from { opacity: 0; transform: translateY(9px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@media (max-width: 768px) {\n  .follow-page-overlay { align-items: flex-end; padding: 0; }\n\n  .follow-page {\n    width: 100%;\n    height: min(82vh, 680px);\n    border-radius: 20px 20px 0 0;\n    animation-name: follow-sheet-in;\n  }\n\n  .follow-page.closing { animation-name: follow-sheet-out; }\n\n  .follow-header { min-height: 70px; padding: 17px 14px 12px; }\n\n  .follow-list { padding: 5px 12px 16px; }\n}\n\n@keyframes follow-sheet-in {\n  from { opacity: 0; transform: translateY(38px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes follow-sheet-out {\n  to { opacity: 0; transform: translateY(38px); }\n}\n\n@media (max-width: 600px) {\n  .profile-display-name {\n    align-items: flex-start;\n  }\n\n  .profile-display-name h2,\n  .profile-info .profile-display-name h2 {\n    overflow: visible;\n    margin: 0 0 5px;\n    font-size: clamp(.78rem, 3.5vw, .96rem);\n    line-height: 1.25;\n    overflow-wrap: anywhere;\n    text-overflow: clip;\n    white-space: normal;\n  }\n\n  .profile-display-name .verified-badge {\n    margin-top: 1px;\n  }\n}\n.native-profile-menu-wrap,\n.native-profile-tab-icon,\n.native-profile-dock {\n  display: none;\n}\n.profile-share-btn { display: inline-flex; align-items: center; justify-content: center; gap: 7px; }\n.profile-share-overlay { position: fixed; z-index: 12000; inset: 0; display: grid; place-items: center; padding: 18px; background: rgba(8,25,38,.62); backdrop-filter: blur(8px); }\n.profile-share-panel { width: min(100%, 480px); max-height: min(760px, 90vh); overflow: auto; padding: 22px; border: 1px solid rgba(233,90,19,.28); border-radius: 24px; background: #fff; box-shadow: 0 30px 80px rgba(7,29,43,.3); }\n.profile-share-header { display: flex; align-items: center; justify-content: space-between; gap: 15px; }\n.profile-share-header span { color: #e95a13; font-size: .62rem; font-weight: 900; letter-spacing: .15em; }\n.profile-share-header h3 { margin: 4px 0 0; color: #17364b; font-size: 1.2rem; }\n.profile-share-header button { display: grid; width: 38px; height: 38px; place-items: center; border: 0; border-radius: 12px; color: #17364b; background: #edf3f6; cursor: pointer; }\n.profile-share-link { display: grid; grid-template-columns: 1fr auto auto; gap: 8px; align-items: center; margin-top: 18px; padding: 10px; border-radius: 15px; background: #f0f4f6; }\n.profile-share-link > span { min-width: 0; overflow: hidden; color: #58758a; font-size: .72rem; text-overflow: ellipsis; white-space: nowrap; }\n.profile-share-link button { display: inline-flex; min-height: 36px; align-items: center; gap: 5px; padding: 0 10px; border: 0; border-radius: 10px; color: #e95a13; background: #fff; font-size: .7rem; font-weight: 800; cursor: pointer; }\n.profile-share-panel h4 { margin: 20px 0 8px; color: #17364b; font-size: .82rem; }\n.profile-share-matches { display: grid; gap: 6px; max-height: 260px; overflow: auto; }\n.profile-share-matches > p { color: #71899b; font-size: .78rem; }\n.profile-share-matches > button { display: flex; min-height: 55px; align-items: center; gap: 10px; padding: 7px 10px; border: 1px solid #e0e9ee; border-radius: 13px; color: #17364b; background: #fff; font-weight: 800; cursor: pointer; }\n.profile-share-matches > button.selected { border-color: #e95a13; background: #fff5ef; }\n.profile-share-matches img, .profile-share-fallback { display: grid; width: 38px; height: 38px; flex: 0 0 38px; place-items: center; border-radius: 50%; object-fit: cover; color: #fff; background: #4e7799; }\n.profile-share-matches button > span:nth-child(2) { flex: 1; overflow: hidden; text-align: left; text-overflow: ellipsis; }\n.profile-share-matches i { display: grid; width: 24px; height: 24px; place-items: center; border-radius: 50%; color: #fff; background: #e95a13; font-style: normal; }\n.profile-share-send { display: flex; width: 100%; min-height: 46px; align-items: center; justify-content: center; gap: 8px; margin-top: 14px; border: 0; border-radius: 13px; color: #fff; background: #e95a13; font-weight: 900; cursor: pointer; }\n.profile-share-send:disabled { opacity: .4; cursor: default; }\n.profile-share-feedback { margin: 12px 0 0; color: #168360; font-size: .76rem; font-weight: 800; text-align: center; }\n@media (max-width: 600px) { .profile-share-overlay { align-items: end; padding: 0; } .profile-share-panel { width: 100%; max-height: 86vh; border-radius: 24px 24px 0 0; padding: 19px 15px 25px; } .profile-share-link { grid-template-columns: 1fr 1fr; } .profile-share-link > span { grid-column: 1 / -1; } .profile-share-link button { justify-content: center; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
